import React from 'react';
import moment from 'moment/moment';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const BlogSideNav = () => {
    const storeBlogs = useSelector((state) => state.storeBlogs.value)
    const recentPosts = storeBlogs.slice(0, 2)
    return (
        <div className='space-y-12 max-w-sm'>

            <div className='space-y-4'>
                <div className='text-3xl font-bold'>Find the Best Health Insurance Coverage in Your State:</div>
                <div className='space-y-2 flex flex-col items-center px-10'>
                    <Link to='/individual-family-health' className='w-full'><button className='btn btn-secondary w-full btn-lg text-base-100'>Individual & Family Health Quote</button></Link>
                    <Link to='/group-health' className='w-full'><button className='btn btn-secondary w-full btn-lg text-base-100'>Group Health Quote</button></Link>
                </div>
            </div>

            <div className='space-y-4'>
                <div className='text-3xl font-bold'>Recent Post</div>
                <div className='px-10 space-y-4'>
                    {
                        recentPosts.map(post => (
                            <div key={post.id}>
                                <Link className='font-bold hover:underline' to={`/blog/${post.id}`}>{post.title.rendered}</Link>
                                <p>{moment(post.date).format('MMMM D, YYYY')}</p>
                            </div>
                        ))
                    }

                </div>
            </div>

        </div>
    );
}

export default BlogSideNav;
